"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeZoneVisibilityKeys = exports.timeZoneKeys = exports.timeFormatKeys = exports.getTimeSettings = void 0;

/**
 * Time Service
 * Provides cross-domain, agnostic time formatting utilities
 *
 * While primarily used for Events, these utilities should be honored across the entire system
 * for consistent time display formatting (12h/24h, timezone visibility, etc.)
 *
 * TimeConfig is fetched from backend endpoints:
 * - /event/eventTimeSettings (destination)
 * - /settings/eventSettings (control)
 */

/**
 * Time configuration from backend
 */

/**
 * Processed time settings for UI rendering
 */
var timeFormatKeys = {
  automatic: 'automatic',
  ampm: 'ampm',
  hours24: 'hours24'
};
exports.timeFormatKeys = timeFormatKeys;
var timeZoneKeys = {
  user: 'user',
  local: 'local'
};
exports.timeZoneKeys = timeZoneKeys;
var timeZoneVisibilityKeys = {
  display: 'display',
  hide: 'hide'
};
/**
 * Converts TimeConfig from backend to TimeSettings for rendering
 * @param timeConfig - The time configuration from backend
 * @param timezoneName - Optional timezone name for event
 * @returns Processed time settings ready for display
 */

exports.timeZoneVisibilityKeys = timeZoneVisibilityKeys;

var getTimeSettings = function getTimeSettings(timeConfig, timezoneName) {
  var lang = typeof navigator !== 'undefined' && navigator.language ? navigator.language : 'en-US'; // show time format based user's locale (automatic option by default)

  var hour12 = !!new Intl.DateTimeFormat(lang, {
    hour: 'numeric'
  }).format(0).match(/\s/);

  if ((timeConfig === null || timeConfig === void 0 ? void 0 : timeConfig.timeFormat) !== timeFormatKeys.automatic) {
    hour12 = (timeConfig === null || timeConfig === void 0 ? void 0 : timeConfig.timeFormat) === timeFormatKeys.ampm;
  } // show timezone by default if 'Event's time zone' selected to render the event times in


  var showTimezone = (timeConfig === null || timeConfig === void 0 ? void 0 : timeConfig.timeZone) === timeZoneKeys.local;

  if ((timeConfig === null || timeConfig === void 0 ? void 0 : timeConfig.timeZone) === timeZoneKeys.user) {
    showTimezone = (timeConfig === null || timeConfig === void 0 ? void 0 : timeConfig.timeZoneVisibility) === timeZoneVisibilityKeys.display;
  }

  return {
    hour12: hour12,
    showTimezone: showTimezone,
    eventTimezone: (timeConfig === null || timeConfig === void 0 ? void 0 : timeConfig.timeZone) === timeZoneKeys.local ? timezoneName !== null && timezoneName !== void 0 ? timezoneName : '' : ''
  };
};

exports.getTimeSettings = getTimeSettings;